import {Component, Input, OnInit} from '@angular/core';
import {Pagination} from "@core/bean/pagination";
import {BrowseConfig} from "@core/bean/browse-config";
import {CommonsService} from "@core/service/commons.service";
import {HttpParams, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {BrowseComponent} from "@shared/components/browse/abstract.browse.component";
import {msgSettingsCenterService} from "../../../../routes/jy-msg-management/msg-settings-center/msg-settings-center.service";
import {PageData} from "@core/bean/page-data";

@Component({
  selector: 'app-msg-template-browse',
  templateUrl: './msg-template-browse.component.html',
  styles: []
})
export class MsgTemplateBrowseComponent implements BrowseComponent, OnInit {

  static componentName = 'MsgTemplateBrowseComponent';

  pagination:Pagination = new Pagination();
  //隐藏开关
  visible:boolean = false;
  //父组件相关
  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  constructor(
    private service:msgSettingsCenterService,
    private commons: CommonsService,
  ) {
    this.pagination.getData = function (params: HttpParams): Observable<any> {
      return service.query(params);
    };
    //重写loadData方法
    this.pagination.loadData = () => {
      this.pagination.loading = true;
      this.pagination.getOriginalData(this.pagination.getHttpParams()).subscribe((httpResponse: HttpResponse<any>) => {
        let totalCount = httpResponse.headers.get(this.pagination.HEADER_NAME_TOTALCOUNT);
        let data = httpResponse.body;
        let pageData = new PageData(Number.parseInt(totalCount), data);
        this.pagination.pageData = pageData;
        for (let i = 0; i < this.pagination.pageData.data.length; i++) {
          let desc: string = this.pagination.pageData.data[i]['description'];
          if (desc == null || desc == '' || desc.length < 25) {
            this.pagination.pageData.data[i]['desc'] = desc;
            continue;
          }
          desc = desc.substring(0, 15) + '...';
          this.pagination.pageData.data[i]['desc'] = desc;
        }
        this.pagination.refreshStatus();
        this.pagination.loading = false;
      }, error => {
        this.pagination.loading = false;
      }, () => {
        this.pagination.loading = false;
      });
    };
  }

  ngOnInit() {
    this.getData();
    this.visible = true;
    if (!this.config.multiple){
      this.pagination.multipleCheck = false;
    }
  }

  getData(){
    this.pagination.searchData = this.config.searchData;
    this.pagination.toFirstPage();
  }

  //重置搜索条件
  reset(){
    this.config.searchData = {};
    this.pagination.searchData = {}
  }

  //关闭
  modalCancel(){
    this.visible = false;
    this.onCancel();
  }

  //确定
  modalOk(){
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commons.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commons.showWarningMessage("commons.info.selectData");
      }
    }
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commons.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commons.showWarningMessage("commons.info.selectData");
      }
    }
  }
}
